import { Action } from '@ngrx/store';
import { ActionOptionsArgs, SynchronisableAction } from '../../../core/store/actions/base-actions';
import { ReportLayout } from './report-layout.model';

export const ENTITY = 'reportLayout';
export const SUBMIT = '[ReportLayout] Submit';
export const REHYDRATE = '[ReportLayout] Rehydrate';
export const REMOVE = '[ReportLayout] Remove';

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: ReportLayout, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly type = REHYDRATE;

    constructor(public payload: Array<ReportLayout>) {

    }
}

export class RemoveAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: ReportLayout, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export type Actions
    = SubmitAction
    | RehydrateAction
    | RemoveAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/report-layout/report-layout.actions.ts